<div class="relative w-full h-1">
  <div class="absolute top-0 left-0 w-full h-full bg-cyan/50 rounded-lg"></div>
  <div
    class="absolute top-0 left-0 h-full bg-cyan rounded-lg transition-width duration-150"
    [style.width]="progress + '%'"
  ></div>
</div>
